import '.aq{display:block;}.ssr-plugin'
import '.b7{margin-bottom:8px;}.ssr-plugin'
import '.gi{font-family:Neulis-Regular;}.ssr-plugin'
import '.cd{font-size:16px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.gj{padding:0px 12px;}.ssr-plugin'
import '.z{height:44px;}.ssr-plugin'
import '.gk{max-height:44px;}.ssr-plugin'
import '.dj{min-height:44px;}.ssr-plugin'
import '.gl{background-color:transparent;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.dh{outline:none;}.ssr-plugin'
import '.gm{transition:box-shadow 150ms ease, border-color 200ms ease;}.ssr-plugin'
import { ChangeEvent } from 'react'
import { Style, styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type TextInputProps = {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void
  error?: boolean
  label?: string
  placeholder?: string
  id?: string
  style?: Style
}

export const TextInput = ({
  value,
  onChange,
  onBlur,
  error,
  style,
  id,
  label,
  placeholder,
}: TextInputProps) => {
  return (
    <styled.div style={style}>
      <label className="subtext aq b7"
        style={{
          color: error ? colors.red : colors.white,
          opacity: error ? 1 : 0.5,
        }}
      >
        {label}
      </label>
      <styled.input className="gi cd a gj z gk dj gl cq dh gm"
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        style={{
          color: colors.white,
          border: error
            ? `1px solid ${colors.red}`
            : `1px solid rgba(255,255,255,0.24)`,
          '&::placeholder': {
            color: `${transparentColor(colors.white, 0.5)}`,
            fontFamily: 'Neulis-Regular',
          },
          '&:focus': {
            border: `1px solid ${colors.white}`,
            boxShadow: `0 0 0 3px ${transparentColor(colors.white, 0.35)}`,
          },
        }}
      />
    </styled.div>
  )
}
